document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".project-photo-section").forEach(section => {
    const sectionId = section.getAttribute("data-section-id");
    const listItems = section.querySelectorAll(".list-itemphoto");
    const popup = document.querySelector(`.project-photo-section-popup-${sectionId}`); // popup 是全局的，所以仍保持原选择器
    const closeBtn = popup.querySelector(".close_button");
    const first = section.querySelector(".div-block-150");
    const body = document.body;
    const swiper = new Swiper(`.project-photo-section-popup-${sectionId} .photoSwiper`, {
      loop: true,
      spaceBetween: 10,
      slidesPerView: 5,
      freeMode: true,
      watchSlidesProgress: true,
      breakpoints: {
        768: {
          spaceBetween: 10,
          slidesPerView: 8,
        },
      },
    });

    const swiper2 = new Swiper(`.project-photo-section-popup-${sectionId} .photoSwiper2`, {
      loop: true,
      spaceBetween: 10,
      thumbs: {
        swiper: swiper,
      },
      breakpoints: {
        768: {
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        },
      },
      on: {
        init() {
          if (window.innerWidth < 768) {
            popup.querySelector(".swiper-button-next").style.display = "none";
            popup.querySelector(".swiper-button-prev").style.display = "none";
          }
        },
        resize() {
          if (window.innerWidth < 768) {
            popup.querySelector(".swiper-button-next").style.display = "none";
            popup.querySelector(".swiper-button-prev").style.display = "none";
          } else {
            popup.querySelector(".swiper-button-next").style.display = "block";
            popup.querySelector(".swiper-button-prev").style.display = "block";
          }
        },
      },
    });

    listItems.forEach((item, index) => {
      item.addEventListener("click", function () {
        popup.style.display = "block";
        popup.style.opacity = "1";
        swiper2.slideTo(index + 1, 0, false); // 因为 index 从第2张开始
        body.classList.add('no-scroll');
      });
    });

    first.addEventListener("click", function () {
      popup.style.display = "block";
      popup.style.opacity = "1";
      swiper2.slideTo(0, 0, false); // 第一张
      body.classList.add('no-scroll');
    });

    closeBtn.addEventListener("click", function () {
      popup.style.display = "none";
      popup.style.opacity = "0";
      body.classList.remove('no-scroll');
    });
  })
  
});
